
import React, { useState, useRef, useEffect, useCallback } from 'react'
import PhotosListItem from './photosListItem';
import useInfiniteSearch from '../utils/useInfiniteSearch';
import styled from 'styled-components'

export default function PhotosInfiniteList(props) {

  useEffect(() => {
    props.filterQuery.current = handleSearch
  }, []);

    const Container = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
  `;

  const [query, setQuery] = useState( {} );
  const [pageNumber, setPageNumber] = useState(1);

  const {
    datas,
    hasMore,
    loading,
    error
  } = useInfiniteSearch(`${process.env.REACT_APP_API_BASE_URL}/api/photos`, query, pageNumber);

  const observer = useRef()
  
  const lastItemElementRef = useCallback(node => {
    if (loading) return
    if (observer.current) observer.current.disconnect()
  
    observer.current = new IntersectionObserver(entries => {
      if (entries[0].isIntersecting && hasMore) {
        setPageNumber(prevPageNumber => prevPageNumber + 1)
      }
    })
    if (node) observer.current.observe(node)
  }, [loading, hasMore])

  function handleSearch(array) {
    setQuery({countries: array.join(',')})
    setPageNumber(1)
  }

  function checkString(stringData) {
    if (stringData && stringData != "") {
      return stringData;
    }

    return "N/A";
  }

  return (
    <>
        <Container>
            {datas.map((item, index) => {
              if (datas.length > 15 && index === datas.length - 10) {
                return <><PhotosListItem key={checkString(item.Id)} descr={checkString(item.Description)} source={checkString(item.SourceName)} country={checkString(item.Country)} link={`/photos/${item.Id}`}/><div ref={lastItemElementRef}></div></>
              } else {
                return <PhotosListItem key={checkString(item.Id)} descr={checkString(item.Description)} source={checkString(item.SourceName)} country={checkString(item.Country)} link={`/photos/${item.Id}`}/>
              }
            })}
            <div>{loading && 'Loading...'}</div>
            <div>{error && 'Error'}</div>
        </Container>
    </>
  )
}